import React from "react";

const CustomDeleteModal = ({
  modalId,
  title,
  button1,
  button2,
  onDelete,
  onCancel,
  content1,
  content2,
  keyId
}) => {
  // console.log(title)
  return (
    <div
    className="modal fade"
      key={keyId}
      id={modalId}
      data-bs-keyboard="false"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content blog_modal_content com_deletemodal88" style={{borderRadius:'15px'}} >
          <div className="modal-header border-0 text-center" style={{backgroundColor:'rgba(31, 126, 120, 0.05)'}}>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onCancel}
            ></button>
          </div>
          <div className="modal-body pb-4" style={{backgroundColor:'rgba(31, 126, 120, 0.05)'}}>
            <p className="modal_text_body_component" >
              {content1}
            </p>
          </div>
          <div className="" style={{backgroundColor:'rgba(31, 126, 120, 0.2)'}} >
            <div className="d-flex w-100 justify-content-center " style={{borderRadius:'15px'}}>
              <div
                style={{
                  cursor: "pointer",
                  backgroundColor: "rgba(31, 126, 120, 0)",
                  color: "red",
                  border: "1px solid #bbb9b9",
                  height: "48px",
                  width: "50%",
                  borderRadius:'0px 0px 0px 15px'
                }}
                className=" d-flex justify-content-center align-items-center"
                data-bs-dismiss="modal"
                onClick={onDelete}
              >
                {button1}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  backgroundColor: "rgba(31, 126, 120, 0)",
                  color: "blue",
                  border: "1px solid #bbb9b9",
                  height: "48px",
                  width: "50%",
                  borderRadius:'0px 0px 15px 0px'
                }}
                className=" d-flex justify-content-center align-items-center"
                data-bs-dismiss="modal"
                onClick={onCancel}
              >
                {button2}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomDeleteModal;
